import {type AggregatedStoppageRcfaAvailability} from '@hconnect/common/stoppages/types/stoppage.types'
import {calcRelativeValueInPercent} from '@hconnect/uikit'
import {type TFunction} from 'i18next'

import {type RcfaStatusTableItem} from '../types'

export const mapAggregatedStoppageRcfaAvailabilityToRcfaStatusTable = (
  data: AggregatedStoppageRcfaAvailability,
  t: TFunction
): RcfaStatusTableItem[] => {
  const result: RcfaStatusTableItem[] = []
  if (!data) {
    return result
  }
  const missingRcfas = data.longKilnStoppageCount - data.longKilnStoppageRcfaCount
  const optionalRcfas = data.stoppageRcfaCount - data.longKilnStoppageRcfaCount
  const kilnStoppages = data.kilnStoppageCount

  const total = missingRcfas + optionalRcfas + kilnStoppages

  result.push({
    rowKey: 'missingRcfas',
    column: t('rcfaStatus.label.missingRCFAs'),
    absoluteNumber: missingRcfas,
    percentage:
      missingRcfas > 0 ? Math.round(calcRelativeValueInPercent(missingRcfas, 0, total)) : 0
  })
  result.push({
    rowKey: 'optionalRcfas',
    column: t('rcfaStatus.label.optionalRCFAs'),
    absoluteNumber: optionalRcfas,
    percentage:
      optionalRcfas > 0 ? Math.round(calcRelativeValueInPercent(optionalRcfas, 0, total)) : 0
  })
  result.push({
    rowKey: 'kilnStoppages',
    column: t('rcfaStatus.label.kilnStoppages'),
    absoluteNumber: kilnStoppages,
    percentage:
      kilnStoppages > 0 ? Math.round(calcRelativeValueInPercent(kilnStoppages, 0, total)) : 0
  })
  return result
}
